<template>
  <PreloaderVac/>
  <div class="home">
    <div class="container">
      <div class="home-wrapper">
        <div class="home-wrapper_left">
          <h2>The easiest way to buy a car in Canada</h2>
          <router-link to="/Request" class="home-request">Request a suv</router-link>
        </div>
        <div class="home-wrapper_right">
          <swiper
            :navigation = "true"
            :modules="modules"
            class="mySwiper"
          >
            <swiper-slide
              ><img class="swiper-home_img"
                src="../assets/img/home-page/SUV.png" /></swiper-slide
            ><swiper-slide
              ><img class="swiper-home_img"
                src="../assets/img/home-page/CAR.png" /></swiper-slide
            ><swiper-slide
              ><img class="swiper-home_img"
                src="../assets/img/home-page/TRUCK.png"/></swiper-slide
            ><swiper-slide
              ><img class="swiper-home_img"
                src="../assets/img/home-page/VAN.png" /></swiper-slide>
            <!-- <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div> -->
          </swiper>
        </div>
        <router-link to="/Request" class="home-request2">Request a suv</router-link>
      </div>
    </div>
  </div>

  <div class="doeswork">
    <div class="doeswork-main">
      <img class="doeswork-main_img1" src="../assets/img/home-page/Honda-Accord.png" alt="">
      <div class="doeswork-main_from">
        <h2>How does it work?</h2>
        <h3>From your Phone to your Home</h3>
        <p>We make it easy for you to buy your dream car from your phone without ever having to step into a dealership! We deliver your vehicle to your home for you to test drive before you sign anything.</p>
      </div>
      <img class="doeswork-main_img2" src="../assets/img/home-page/Lexus.png" alt="">
    </div>
  </div>

  <div class="perfectcar">
    <div class="container">
      <h2>Your perfect car in 5 easy steps</h2>
      <div class="perfectcar-main">
        <div class="perfectcar-main_left">
          <div class="left-contact">
            <div class="left-contact_main">
              <img src="../assets/img/home-page/Step1.png" alt="">
              <div>
                <h5>First Contact</h5>
                <p>Tell us what your dream vehicle is.</p>
              </div>
            </div>
            <div class="left-contact_main">
              <img src="../assets/img/home-page/Step2.png" alt="">
              <div>
                <h5>Vehicle Selection</h5>
                <p>One of our Qualified Agents sends you custom pictures and videos of the car you are interested in.</p>
              </div>
            </div>
            <div class="left-contact_main">
              <img src="../assets/img/home-page/Step3.png" alt="">
              <div>
                <h5>Secure Financing</h5>
                <p>You work with a dedicated Qualified Agent to secure financing on your terms.</p>
              </div>
            </div>
            <div class="left-contact_main">
              <img src="../assets/img/home-page/Step4.png" alt="">
              <div>
                <h5>Vehicle Delivery</h5>
                <p>We deliver your car to your home or office for you to test drive.</p>
              </div>
            </div>
            <div class="left-contact_main">
              <img src="../assets/img/home-page/Step5.png" alt="">
              <div>
                <h5>Getting Vehicle</h5>
                <p>If you love the vehicle, you sign the paperwork and keep the car.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="perfectcar-main_right">
          <img class="perfectcar-img" src="../assets/img/home-page/Image.png" alt="">
          <img class="perfectcar-img2" src="../assets/img/home-page/Image2.png" alt="">
        </div>
      </div>
    </div>
  </div>

  <div class="advantages">
    <div class="container">
      <h2>Advantages of working with us</h2>
      <div class="advantages-main">
        <div class="advantages-main_left">
          <img src="../assets/img/home-page/advantages.png" alt="">
          <h5>Vehicle Delivery</h5>
          <p>We deliver your vehicle directly to your door. You don’t sign anything until you test drive the vehicle. There is never any obligation to buy beforehand.</p>
        </div>
        <div class="advantages-main_center">
          <img src="../assets/img/home-page/advantages2.png" alt="">
          <h5>Auto Financing</h5>
          <p>We partner with the largest lenders in Canada to offer the strongest financing options in the industry—including rates as low as 4%</p>
        </div>
        <div class="advantages-main_right">
          <img src="../assets/img/home-page/advantages3.png" alt="">
          <h5>Huge Inventory</h5>
          <p>We have access to thousands of high-quality vehicles and offer them to you at wholesale prices. Your dream car is waiting for you</p>
        </div>
      </div>
    </div>
  </div>

  <div class="chooseyour">
    <div class="container">
      <div class="chooseyour-main">
        <div class="chooseyour-main_left">
          <img src="../assets/img/home-page/Cars.png"  alt="">
        </div>
        <div class="chooseyour-main_right">
          <h2>Сhoose your dream vehicle in our catalog</h2>
          <div>
            <p>In our catalogue there are many models of vehicles. Choose your car to your liking.</p>
            <router-link to="/inventory" class="home-inventory">Inventory</router-link>
          </div>
         
        </div>
      </div>
    </div>
  </div>

  <div class="happycustomers">
    <div class="container">
      <div class="happycustomers-main">
        <div class="happycustomers-main_left">
          <h2>Happy customers</h2>
          <p>Since 2017, we have helped thousands of Canadians get their dream vehicles from the comfort of their homes. </p>
          <h3>What are you waiting? <br>Get started right now!</h3>
          <router-link to="/Request" class="happycustomers-require">Request a Car</router-link>
        </div>
        <div class="happycustomers-main_right">
          <div class="happycustomers-card">
            <h2>7,988+</h2>
            <p>Sold Cars</p>
          </div>
          <div class="happycustomers-card">
            <h2>16,974+</h2>
            <p>Vehicles To Choose From</p>
          </div>
          <div class="happycustomers-card">
            <h2>123</h2>
            <p>Experts Across Canada</p>
          </div>
        </div>
        <div class="happycustomers-main_bottom">
          <h3>What are you waiting? <br>Get started right now!</h3>
          <router-link to="/Request" class="happycustomers-require2">Request a Car</router-link>
        </div>
      </div>
    </div>
  </div>

  <WhatOur />

  <CalculatorInput class="letsfigure" />

  <BlogSlider :titleBlogArticle="titleBlogArticle"/>

</template>

<script>

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';

import "swiper/css/navigation";

//import "./style.css";

import { Navigation } from "swiper";

import CalculatorInput from '../components/CalculatorInput.vue'
import WhatOur from '../components/WhatOur.vue'
import BlogSlider from '../components/BlogSlider.vue'
import PreloaderVac from './PreloaderVac.vue'


export default {

  data(){
    return{
      titleBlogArticle: 'Interesting to read',
    }
  },

  components: {
      Swiper,
      SwiperSlide,
      CalculatorInput,
      WhatOur,
      BlogSlider,
      PreloaderVac,
    },
    setup() {
      return {
        modules: [Navigation],
      };
  },

  computed: {
        blogCarts(){
            return this.$store.getters.blogCarts
        },
        visibleList: function(){
          return this.blogCarts.slice(0, 3);
        }
    },
};

</script>

<style lang="scss">

@import '../assets/scss/breakpoints.scss';

                                      //HOME

.home {
  background-image: url(../assets/img/home-page/Bg.jpg);
  background-size: 100% 100%;
  height: 600px;

  @include breakpoints(lg){
    background-size: cover;
    height: 790px;
  }
  @include breakpoints(lgm){
    height: 725px;
  }
  @include breakpoints(sm){
    height: 515px;
  }
}

.home-wrapper {
  display: flex;
  justify-content: space-between;
  padding-top: 120px;

  @include breakpoints(lg){
    padding-top: 61px;
    justify-content: center;
    flex-direction: column;
    gap: 60px;
    align-items: center;
  }
  @include breakpoints(md){
    width: 90%;
    margin: 0 auto;
  }
  @include breakpoints(sm){
    width: 100%;
    padding-top: 50px;
    gap: 40px;
  }
}
.home-wrapper_left {
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 60px;
  @include breakpoints(lg){
    width: 100%;
  }
  h2{
    font-family: 'Gilroy800';
    font-size: 60px;
    line-height: 108.5%;
    letter-spacing: 0.02em;
    color: #FFFFFF;
    width: 70%;
    @include breakpoints(xl){
      width: 90%;
    }
    @include breakpoints(lg){
      width: 100%;
      text-align: center;
    }
    @include breakpoints(sm){
      width: 90%;
      margin: 0 auto;
      font-size: 35px;
    }
  }
}
.home-request, .home-request2 {
  background: #FFFFFF;
  border-radius: 2px;
  font-family: 'Gilroy700';
  font-size: 16px;
  line-height: 14px;
  text-align: center;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #7481FF;
  padding: 16px 15px;
  width: 200px;
  @include breakpoints(lg){
    display: none;
  }
  @include breakpoints(sm){
    font-size: 14px;
    width: 214px;
    padding: 10px 15px;
  }
}

.home-request2{
  display: none;
  @include breakpoints(lg){
    display: block;
  }
}
.home-wrapper_right {
  width: 50%;
  padding-top: 57px;
  @include breakpoints(lg){
      width: 100%;
      padding-top: 0;
  }
}
.swiper-home_img{
  width: 80%;
  height: 100%;
  margin-left: 10%;
}
.mySwiper{
  .swiper-button-next{
  background-image: url(../assets/img/home-page/arrow-next.png);
  background-repeat: no-repeat;
  width: 53px;
  height: 53px;
  background-size: 100% 100%;
  @include breakpoints(sm){
    width: 35px;
    height: 35px;
  }

  &::after{
    display: none;
  }
}
.swiper-button-prev{
  background-image: url(../assets/img/home-page/arrow-prev.png);
  background-repeat: no-repeat;
  width: 53px;
  height: 53px;
  background-size: 100% 100%;
  @include breakpoints(sm){
    width: 35px;
    height: 35px;
  }

  &::after{
    display: none;
  }
}
}



                                    //DOESNWOR

.doeswork {
  width: 100%;
}
.doeswork-main {
  display: flex;
  justify-content: space-between;
  @include breakpoints(xl){
    position: relative;
    overflow: hidden;
    padding: 0 0 18%;
    margin-top: -40px;
  }
  @include breakpoints(lg){
    padding: 0 0 24%;
  }
  @include breakpoints(md){
    padding: 0 0 34%;
  }
  @include breakpoints(sm){
      padding: 0 20px 32%;
  }

  &_img1{
    width: 30%;
    padding-right: 10px;
    padding-top: 190px;
    @include breakpoints(xl){
      position: absolute;
      padding-top: 398px
    }
    @include breakpoints(lg){
      width: 40%;
    }
    @include breakpoints(sm){
      width: 45%;
      left: 0;
      top: 72%;
      padding-top: 0;
    }
    @include breakpoints(sms){
      top: 80%;
    }
  }

  &_img2{
    width: 30%;
    margin-left: -2%;
    padding: 26px 0 107px 0;
    @include breakpoints(xl){
      position: absolute;
      right: 0;
      top: 250px;
    }
    @include breakpoints(lg){
      width: 40%;
      right: -59px;
      top: 280px;
    }
    @include breakpoints(sm){
      width: 45%;
      right: -35px;
      top: 50%;
    }
    @include breakpoints(sms){
      top: 60%;
    }
  }
}
.doeswork-main_from {
  background: #FFFFFF;
  box-shadow: 0px 20px 25px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 60px 60px 64px 60px;
  margin-top: -40px;
  height: 365px;
  z-index: 1;
  width: 40%;
  @include breakpoints(xl){
      width: 60%;
      margin: 0 auto;
  }
  @include breakpoints(lg){
      width: 85%;
  }
  @include breakpoints(md){
      padding: 40px;
      height: 100%;
  }
  @include breakpoints(sm){
      padding: 20px;
      width: 100%;
  }

  h2{
    font-family: 'Gilroy700';
    font-size: 45px;
    line-height: 140.5%;
    text-align: center;
    color: #41456B;

    @include breakpoints(sm){
      font-size: 30px;
    }
  }

  h3{
    font-family: 'Gilroy700';
    font-size: 30px;
    line-height: 140%;
    text-align: center;
    color: #7481FF;
    @include breakpoints(sm){
      font-size: 24px;
    }
  }

  p{
    font-family: 'Gilroy400';
    font-size: 16px;
    line-height: 180%;
    text-align: center;
    letter-spacing: 0.02em;
    color: #606276;
    padding-top: 20px;
    @include breakpoints(sm){
      padding-top: 10px;
    }
  }
}

                                  //PERFECTCAR

.perfectcar {
  margin-top: 225px;

  @include breakpoints(md){
    margin-top: 160px;
  }
  @include breakpoints(sm){
    margin-top: 80px;
  }

  h2{
    font-family: 'Gilroy700';
    font-size: 45px;
    line-height: 140.5%;
    color: #41456B;
    width: 35%;

    @include breakpoints(xl){
      width: 45%;
    }
    @include breakpoints(lg){
      width: 100%;
    }
    @include breakpoints(sm){
      font-size: 30px;
    }
  }
}
.perfectcar-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 60px;
  @include breakpoints(sm){
    justify-content: flex-start;
    flex-direction: column;
  }
}
.perfectcar-main_left {
  width: 50%;
  @include breakpoints(lg){
      width: 60%;
  }
  @include breakpoints(sm){
      width: 100%;
  }

}
.left-contact {
  display:  flex;
  flex-direction: column;
  gap: 40px;
 // padding-top: 60px;
  @include breakpoints(lg){
    padding-top: 0;
  }
  @include breakpoints(sm){
      gap: 20px;
      padding-top: 30px;
  }
}
.left-contact_main {
  display: flex;
  align-items: center;
  gap: 20px;
  @include breakpoints(sm){
      align-items: flex-start;
  }

  img{
    @include breakpoints(sm){
      width: 53px;
      height: 47px;
  }
  }

  div{
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 60%;
    @include breakpoints(lg){
      width: 75%;
    }
    @include breakpoints(sm){
      width: 100%;
    }

    h5{
      font-family: 'Gilroy600';
      font-size: 20px;
      line-height: 25px;
      color: #41456B;
      @include breakpoints(sm){
        font-size: 18px;
      }
    }

    p{
      font-family: 'Gilroy400';
      font-size: 16px;
      line-height: 180%;
      letter-spacing: 0.02em;
      color: #606276;
    }
  }
}
.perfectcar-main_right {
  width: 45%;
 // margin-top: 60px;
  @include breakpoints(xl){
    width: 55%;
  }
  @include breakpoints(lg){
    width: 37%;
  }
  @include breakpoints(md){
    width: 50%;
  }
  @include breakpoints(sm){
    width: 100%;
    height: 327px;
    margin-top: 30px;
  }

}
.perfectcar-img{
    width: 100%;
    @include breakpoints(lg){
      display: none;
    }
    @include breakpoints(sm){
      display: block;
    }
  }
.perfectcar-img2{
  display: none;
  width: 100%;
  @include breakpoints(lg){
    display: block;
  }
  @include breakpoints(sm){
    display: none;
  }
}

                                  //ADVANTAGES

.advantages {
  margin-top: 220px;
  @include breakpoints(md){
    margin-top: 160px;
  }
  @include breakpoints(sm){
    margin-top: 80px;
  }

  h2{
    font-family: 'Gilroy700';
    font-size: 45px;
    line-height: 140.5%;
    color: #41456B;
    @include breakpoints(lg){
      text-align: center;
    }
    @include breakpoints(sm){
      font-size: 30px;
    }
  }

  h5{
    font-family: 'Gilroy600';
    font-size: 20px;
    line-height: 25px;
    text-align: center;
    color: #41456B;
    @include breakpoints(sm){
      font-size: 18px;
    }
  }
}
.advantages-main {
  display: flex;
  margin-top: 60px;
  margin-bottom: 480px;
  @include breakpoints(lg){
    flex-direction: column;
    gap: 47px;
    margin-bottom: 0;
  }
  @include breakpoints(md){
    margin-top: 40px;
    gap: 30px;
  }
  @include breakpoints(sm){
    margin-top: 30px;
    gap: 20px;
  }
}
.advantages-main_left {
  background-image: url(../assets/img/home-page/Vector.png);
  background-size: 100% 100%;
  height: 480px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 136px;
  gap: 5px;
  position: absolute;
  width: 35%;
  left: 5%;
  @include breakpoints(lg){
    position: relative;
    width: 85%;
    margin: 0 auto;
    left: 0;
  }
  @include breakpoints(md){
    width: 100%;
  }
  @include breakpoints(sm){
    background-image: none;
    padding-top: 0;
    height: 100%;
  }


  p{
    font-family: 'Gilroy400';
    font-size: 16px;
    line-height: 180%;
    text-align: center;
    letter-spacing: 0.02em;
    color: #606276;
    width: 60%;
    @include breakpoints(sm){
      width: 100%;
    }
  }
}
.advantages-main_center {
  background-image: url(../assets/img/home-page/Vector2.png);
  background-size: 100% 100%;
  height: 480px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 33px;
  gap: 5px;
  position: absolute;
  width: 37%;
  left: 32%;
  @include breakpoints(lg){
    position: relative;
    width: 85%;
    margin: 0 auto;
    left: 0;
    padding-top: 136px;
    background-image: url(../assets/img/home-page/Vector.png);
  }
  @include breakpoints(md){
    width: 100%;
  }
  @include breakpoints(sm){
    background-image: none;
    padding-top: 0;
    height: 100%;
  }

  p{
    font-family: 'Gilroy400';
    font-size: 16px;
    line-height: 180%;
    text-align: center;
    letter-spacing: 0.02em;
    color: #606276;
    width: 40%;
    @include breakpoints(lg){
      width: 60%;
    }
    @include breakpoints(sm){
      width: 100%;
    }
  }
}
.advantages-main_right {
  background-image: url(../assets/img/home-page/Vector.png);
  background-size: 100% 100%;
  height: 480px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 136px;
  gap: 5px;
  position: absolute;
  width: 35%;
  left: 60%;
  @include breakpoints(lg){
    position: relative;
    width: 85%;
    margin: 0 auto;
    left: 0;
  }
  @include breakpoints(md){
    width: 100%;
  }
  @include breakpoints(sm){
    background-image: none;
    padding-top: 0;
    height: 100%;
  }

  p{
    font-family: 'Gilroy400';
    font-size: 16px;
    line-height: 180%;
    text-align: center;
    letter-spacing: 0.02em;
    color: #606276;
    width: 60%;
    @include breakpoints(sm){
      width: 100%;
    }
  }
}

                                  //CHOOSEYOUR

.chooseyour {
  padding-top: 230px;
  @include breakpoints(lg){
    padding-top: 200px;
  }
  @include breakpoints(md){
    padding-top: 160px;
  }
  @include breakpoints(sm){
    padding-top: 80px;
  }
}
.chooseyour-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 100px;

  @include breakpoints(lg){
    flex-direction: column-reverse;
    gap: 60px;
  }
  @include breakpoints(sm){
    gap: 30px;
  }
}
.chooseyour-main_left {
  // background-image: url(../assets/img/home-page/Cars.png);
  // background-size: 100% 100%;
  width: 50%;
  @include breakpoints(lg){
    margin-top: 0;
    width: 100%;
  }
  img{
    width: 100%;
  }
}
.chooseyour-main_right {
  display: flex;
  flex-direction: column;
  width: 50%;
  @include breakpoints(lg){
    width: 100%;
    flex-direction: initial;
    gap: 60px;
  }
  @include breakpoints(md){
    flex-direction: column;
    gap: 30px;
  }
  @include breakpoints(sm){
    gap: 10px;
  }

  h2{
    font-family: 'Gilroy700';
    font-size: 45px;
    line-height: 140.5%;
    color: #41456B;
    border: 1px solid #FFFFFF;
    width: 80%;
    @include breakpoints(lg){
      width: 100%;
    }
    @include breakpoints(sm){
      font-size: 30px;
    }
  }

  p{
    font-family: 'Gilroy400';
    font-size: 16px;
    line-height: 180%;
    letter-spacing: 0.02em;
    color: #606276;
    padding-top: 20px;
    padding-bottom: 40px;
    @include breakpoints(lg){
      padding-top: 12px;
    }
  }
}
.home-inventory {
  display: block;
  background: #7481FF;
  border-radius: 2px;
  padding: 16px 15px;
  font-family: 'Gilroy700';
  font-size: 16px;
  line-height: 14px;
  text-align: center;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #FFFFFF;
  width: 190px;
  @include breakpoints(sm){
    font-size: 14px;
    width: 100%;
    padding: 10px 15px;
  }
}


                               //HAPPYCUSTOMERS

.happycustomers {
  margin-top: 230px;
  @include breakpoints(md){
    margin-top: 160px;
  }
  @include breakpoints(sm){
    margin-top: 80px;
  }
}

.happycustomers-main {
  display: flex;
  justify-content: space-between;
  gap: 50px;
  @include breakpoints(lg){
    flex-direction: column;
    gap: 40px;
  }
  @include breakpoints(sm){
    gap: 20px;
  }
}
.happycustomers-main_left {
  width: 72%;
  display: flex;
  flex-direction: column;
  @include breakpoints(lg){
    width: 100%;
  }

  h2{
    font-family: 'Gilroy700';
    font-size: 45px;
    line-height: 140.5%;
    color: #41456B;
    @include breakpoints(sm){
      font-size: 30px;
    }
  }

  p{
    font-family: 'Gilroy400';
    font-size: 16px;
    line-height: 180%;
    letter-spacing: 0.02em;
    color: #606276;
    padding-top: 20px;
    width: 80%;
    @include breakpoints(xl){
      width: 100%;
    }
  }

  h3{
    font-family: 'Gilroy700';
    font-size: 25px;
    line-height: 140%;
    letter-spacing: 0.02em;
    color: #41456B;
    padding: 40px 0;
    @include breakpoints(lg){
      display: none;
    }
  }
}
.happycustomers-require {
  background: #7481FF;
  border-radius: 2px;
  padding: 16px 15px;
  font-family: 'Gilroy700';
  font-size: 16px;
  line-height: 14px;
  text-align: center;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #FFFFFF;
  width: 200px;

  @include breakpoints(lg){
    display: none;
  }
}
.happycustomers-main_right {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 40px;
}
.happycustomers-card {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 25px 38px 21px 35px;
  background: #FFFFFF;
  box-shadow: 0px 20px 25px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  width: 45%;
  @include breakpoints(sm){
    width: 100%;
    padding: 20px 53px 20px 30px;
  }

  h2{
    font-family: 'Gilroy700';
    font-size: 45px;
    line-height: 140.5%;
    color: #41456B;
    @include breakpoints(sm){
      font-size: 30px;
    }
  }

  p{
    font-family: 'Gilroy400';
    font-size: 16px;
    line-height: 180%;
    letter-spacing: 0.02em;
    color: #606276;
  }
}

.happycustomers-main_bottom{
  display: none;
  flex-direction: column;
  gap: 40px;
  @include breakpoints(lg){
    display: flex;
  }

  h3{
    font-family: 'Gilroy700';
    font-size: 25px;
    line-height: 140%;
    letter-spacing: 0.02em;
    color: #41456B;
    @include breakpoints(sm){
      font-size: 20px;
    }
  }
}
.happycustomers-require2 {
  background: #7481FF;
  border-radius: 2px;
  padding: 16px 15px;
  font-family: 'Gilroy700';
  font-size: 16px;
  line-height: 14px;
  text-align: center;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #FFFFFF;
  width: 200px;
  @include breakpoints(sm){
    width: 100%;
    padding: 10px;
    font-size: 14px;
  }
}

</style>